export default __webpack_public_path__ + "static/media/lions_club@3x.09540966.png";